'use client';

import NewsCardSkeleton from '@/components/NewsCardSkeleton';
import { Tabs } from '@/components/Tabs';
import { TabsContent as DefaultTabsContent } from '@/components/ui/tabs';
import useRouterTransition from '@/utils/useRouterTransition';
import { useParams } from 'next/navigation';
import { createContext, useContext } from 'react';

const NavigationTabsContext = createContext({});

const useNavigationTabs = () => useContext(NavigationTabsContext);

function Loading() {
  return Array.from({ length: 9 }).map((item, index) => <NewsCardSkeleton key={index} />);
}

export const TabsContent = props => {
  const { isPending } = useNavigationTabs();
  const { page } = useParams();

  if (isPending && page !== '1') {
    const { children, ...rest } = props;
    return (
      <DefaultTabsContent {...rest}>
        <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-y-8 md:gap-y-12 lg:gap-x-7 mt-12'>
          <Loading />
        </div>
      </DefaultTabsContent>
    );
  }

  return <DefaultTabsContent {...props} />;
};

export default function NavigationTabs({ children, tabs = [], category }) {
  const router = useRouterTransition();
  const { locale } = useParams();

  return (
    <NavigationTabsContext.Provider value={{ isPending: router?.isPending }}>
      <Tabs
        list={tabs}
        defaultValue={category}
        onChange={value => {
          router.push(`/${locale}/education/${value}/page/1`);
        }}
        onHover={value => {
          router.prefetch(`/${locale}/education/${value}/page/1`);
        }}
      >
        {children}
      </Tabs>
    </NavigationTabsContext.Provider>
  );
}
